import { NodeSpec, Schema, schema } from '@progress/kendo-angular-editor';

const dynamicFieldNode: NodeSpec = {
  attrs: { 'data-dynamic-field-meta-key': { default: null } },
  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  // Parse a custom tag so the sanitizer recognizes it as a *node* you defined.
  parseDOM: [
    {
      tag: 'dynamic-field',
      getAttrs: (dom: HTMLElement) => ({
        'data-dynamic-field-meta-key': dom.getAttribute('data-dynamic-field-meta-key'),
      }),
    },
  ],
  // …but serialize as a <span>, so your stored HTML uses <span>.
  toDOM(node) {
    return ['span', { 'data-dynamic-field-meta-key': node.attrs['data-dynamic-field-meta-key'] }];
  },
};

const nodes = schema.spec.nodes.addToEnd('dynamicField', dynamicFieldNode);
const marks = schema.spec.marks;
export const customSchema = new Schema({ nodes, marks });
